import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FacilityState, FacilityRegion } from '../../types';

const initialState: FacilityState = {
  name: null,
  regions: [],
  visible: false,
  visibleTypes: {},
  minConfidence: 0,
  selectedId: null,
};

const facilitySlice = createSlice({
  name: 'facility',
  initialState,
  reducers: {
    setFacility: (
      state,
      action: PayloadAction<{ name: string; regions: FacilityRegion[]; types: string[] }>
    ) => {
      state.name = action.payload.name;
      state.regions = action.payload.regions;
      state.visible = false;
      state.minConfidence = 0;
      state.selectedId = null;
      const visibleTypes: Record<string, boolean> = {};
      action.payload.types.forEach((t) => {
        visibleTypes[t] = true;
      });
      state.visibleTypes = visibleTypes;
    },
    clearFacility: () => initialState,
    toggleFacilityVisible: (state) => {
      state.visible = !state.visible;
    },
    setFacilityVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;
    },
    toggleFacilityType: (state, action: PayloadAction<string>) => {
      const t = action.payload;
      state.visibleTypes[t] = !state.visibleTypes[t];
    },
    setAllFacilityTypes: (state, action: PayloadAction<boolean>) => {
      Object.keys(state.visibleTypes).forEach((t) => {
        state.visibleTypes[t] = action.payload;
      });
    },
    setMinConfidence: (state, action: PayloadAction<number>) => {
      state.minConfidence = action.payload;
    },
    selectRegion: (state, action: PayloadAction<string | null>) => {
      state.selectedId = action.payload;
    },
  },
});

export const {
  setFacility,
  clearFacility,
  toggleFacilityVisible,
  setFacilityVisible,
  toggleFacilityType,
  setAllFacilityTypes,
  setMinConfidence,
  selectRegion,
} = facilitySlice.actions;

export default facilitySlice.reducer;
